import React, { useState } from "react";
import axios from 'axios';
import { useSelector } from "react-redux";
import { APP_API_URL } from "../../utils";
import Swal from "sweetalert2";

export default function Update({ item, refreshData }) {
  const user = useSelector((state) => state.auth.user);
  const [formData, setFormData] = useState({
    name: item.name || '',
    email: item.email || '',
    numero: item.numero || '',
    adresse: item.adresse,
    code_postal: item.code_postal,
    ifu: item.ifu || '',
    fidelite: item.fidelite || '',
    store_id: item.store.id || '',
    user_id: user?.id || '',
    is_r: false,
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem('token');
      const response = await axios.put(`${APP_API_URL}/customers/${item.id}`, formData, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      // Afficher une alerte de succès avec SweetAlert
      Swal.fire({
        icon: 'success',
        title: 'Mise à jour réussie',
        text: 'Les informations du client ont été mises à jour avec succès.',
        timer: 2000, // Affiche l'alerte pendant 2 secondes
        showConfirmButton: false, // Pas de bouton de confirmation
      });

      // Fermer la modal après un délai
      const closeModal = document.getElementById('updateModalCustomer');
      setTimeout(() => {
        closeModal.click();
        refreshData();
      }, 1000);


    } catch (error) {
      if (error.response && error.response.status === 422) {
        setErrors(error.response.data.errors);
      } else {
        console.error('Erreur lors de l\'envoi du formulaire', error);

        // Afficher une alerte d'erreur avec SweetAlert
        Swal.fire({
          icon: 'error',
          title: 'Erreur',
          text: 'Une erreur est survenue lors de la mise à jour.',
        });
      }
    } finally {
      setLoading(false);
    }
  };
  return (
    <div
      className="modal fade"
      id={`updateModal${item?.id}`}
      tabIndex={-1}
      style={{ display: "none", whiteSpace: 'normal' }}
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <form className="modal-content border-0 overflow-hidden" style={{ borderRadius: '20px' }} onSubmit={handleSubmit}>
          <div className="modal-header text-white border-0" style={{ background: 'linear-gradient(135deg, #006633, #58cc02)' }}>
            <h5 className="modal-title fw-bold">Modifier un client</h5>
          </div>
          <div className="modal-body whitespace-normal">
            <div className="row g-3">
              <div className="col-md-12">
                <label htmlFor="updatename" className="duo-form-label">Nom du client</label>
                <input
                  type="text"
                  className={`duo-input ${errors.name ? 'is-invalid' : ''}`}
                  id="updatename"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                />
                {errors.name && <div className="invalid-feedback">{errors.name[0]}</div>}
              </div>
              <div className="col-md-6">
                <label htmlFor="updateemail" className="duo-form-label">Email</label>
                <input
                  type="email"
                  className={`duo-input ${errors.email ? 'is-invalid' : ''}`}
                  id="updateemail"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
                {errors.email && <div className="invalid-feedback">{errors.email[0]}</div>}
              </div>
              <div className="col-md-6">
                <label htmlFor="updatenumero" className="duo-form-label">Numéro de téléphone</label>
                <input
                  type="text"
                  className={`duo-input ${errors.numero ? 'is-invalid' : ''}`}
                  id="updatenumero"
                  name="numero"
                  value={formData.numero}
                  onChange={handleChange}
                />
                {errors.numero && <div className="invalid-feedback">{errors.numero[0]}</div>}
              </div>
              <div className="col-md-4">
                <label htmlFor="updateadresse" className="duo-form-label">Adresse</label>
                <input
                  type="text"
                  className={`duo-input ${errors.adresse ? 'is-invalid' : ''}`}
                  id="updateadresse"
                  name="adresse"
                  value={formData.adresse}
                  onChange={handleChange}
                />
                {errors.adresse && <div className="invalid-feedback">{errors.adresse[0]}</div>}
              </div>
              <div className="col-md-4">
                <label htmlFor="updatecode_postal" className="duo-form-label">Code Postal</label>
                <input
                  type="text"
                  className={`duo-input ${errors.code_postal ? 'is-invalid' : ''}`}
                  id="updatecode_postal"
                  name="code_postal"
                  value={formData.code_postal}
                  onChange={handleChange}
                />
                {errors.code_postal && <div className="invalid-feedback">{errors.code_postal[0]}</div>}
              </div>
              <div className="col-md-4">
                <label htmlFor="updateifu" className="duo-form-label">IFU</label>
                <input
                  type="text"
                  className={`duo-input ${errors.ifu ? 'is-invalid' : ''}`}
                  id="updateifu"
                  name="ifu"
                  value={formData.ifu}
                  onChange={handleChange}
                />
                {errors.ifu && <div className="invalid-feedback">{errors.ifu[0]}</div>}
              </div>
            </div>
          </div>
          <div className="modal-footer">
            {isLoading ? (
              <button
                type="button"
                disabled
                className="inline-flex items-center rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 transition-all duration-300"
              >
                <svg
                  aria-hidden="true"
                  role="status"
                  className="inline w-4 h-4 me-2 text-white animate-spin"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="#E5E7EB"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentColor"
                  />
                </svg>
                Enregistrement des modifications...
              </button>
            ) : (
              <button type="submit" className="duo-btn duo-btn--primary">
                Enregistrer
              </button>
            )}
            <button
              type="button"
              id="updateModalCustomer"
              data-bs-dismiss="modal"
              className="duo-btn duo-btn--ghost"
            >
              Fermer
            </button>
          </div>
        </form>
      </div>
    </div>
  )
};
